import Decimal from 'decimal.js';
export default Decimal;
